

exports.__esModule = true;
exports['default'] = getSessionStorage;
var store = {};

// Polyfill for sessionStorage if not available. Simple variable store

function getSessionStorage() {
    try {

        window['sessionStorage'].setItem('__feature_test__', '0');
        window['sessionStorage'].removeItem('__feature_test__');
        return window.sessionStorage;
    } catch (err) {
        return {
            getItem: function getItem(key) {
                if (arguments < 1) {
                    throw new Error('1 argument required');
                }
                return store[key];
            },
            setItem: function setItem(key, val) {
                if (arguments < 2) {
                    throw new Error('2 arguments required');
                }
                store[key] = val;
            }
        };
    }
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./components/xo-venmo-components/src/venmo-info/sessionStorage.js
// module id = ./components/xo-venmo-components/src/venmo-info/sessionStorage.js
// module chunks = 1